module.exports = __webpack_public_path__ + "img/android-v1.d929656a.png";